import { usePathname } from 'next/navigation';
import { useWishListStore } from './../store/useWishList';
import usePost from './usePost';
import { toast } from 'react-hot-toast';
import { useState } from 'react';


interface WishListItemLoadingState {
  [productId: string]: boolean;
}

const useWishList = () => {
  const { wishlist, setWishList } = useWishListStore();
  const { PostMethod } = usePost();
  const [loading, setLoading] = useState<WishListItemLoadingState>({});
  const pathname = usePathname();

  const getWishList = async () => {
    try {
      let response = await PostMethod({
        url: 'cart/get-wishlist',
        method: 'get',
        language: pathname.split('/')[1]
      });

      if (response?.success === true) {
        setWishList(response?.data);
      } else {
        setWishList([]);
      }
    } catch (error) {
      toast.error('An error occurred while fetching the wishlist.');
    }
  };

  const setProductLoading = (productId: string, isLoading: boolean) => {
    setLoading((prev) => ({ ...prev, [productId]: isLoading }));
  };

  const addtWishList = async (productId: string) => {
    setProductLoading(productId, true);

    try {
      let response = await PostMethod({
        url: 'cart/add-wishlist',
        body: { productId },
        method: 'post',
      });

      if (response?.success === true) {
        await getWishList();
        toast.success(response?.message);
      } else {
        toast.error(response?.message || 'Failed to add to wishlist.');
      }
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      //   toast.error('An error occurred while adding to the wishlist.');
    } finally {
      setProductLoading(productId, false);
    }
  };

  const removetWishList = async (productId: string) => {
    setProductLoading(productId, true);

    try {
      let response = await PostMethod({
        url: 'cart/remove-wishlist',
        body: { productId },
        method: 'put',
      });

      if (response?.success === true) {
        await getWishList();
        toast.success(response?.message);
      } else {
        toast.error(response?.message || 'Failed to remove from wishlist.');
      }
    } catch (error) {
      console.error('Error removing from wishlist:', error);
    } finally {
      setProductLoading(productId, false);
    }
  };


  return { wishlist, getWishList, addtWishList, removetWishList, loading, setWishList };
};
export default useWishList;
